"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.preproc = exports.setToken = exports.mergeHeader = exports.toResult = void 0;
const pb_1 = require("./pb");
const index_1 = require("./index");
function toResult(response) {
    const result = {};
    result.code = response.getC();
    result.message = response.getM();
    if (response.getDataCase() === pb_1.OutputProto.DataCase.UTF8) {
        result.data = JSON.parse(response.getUtf8());
    }
    else {
        result.data = response.getBs();
    }
    return result;
}
exports.toResult = toResult;
function mergeHeader(methodHeaders, headers) {
    let mh = methodHeaders || {};
    if (headers) {
        Object.keys(headers).forEach((k) => (mh[k] = headers[k]));
    }
    return mh;
}
exports.mergeHeader = mergeHeader;
function setToken(hd, accessToken) {
    if (accessToken) {
        hd[index_1.H_AUTH] = 'Bearer ' + accessToken;
    }
    else {
        delete hd[index_1.H_AUTH];
    }
}
exports.setToken = setToken;
function preproc(cfg) {
    let { host, app, clientId, clientMeta, headers } = cfg;
    if (!host.startsWith('http')) {
        throw new index_1.RpcError(3, 'only http(s):// host support!');
    }
    var hd = headers || {};
    if (clientId) {
        hd[index_1.H_C_ID] = clientId;
    }
    if (clientMeta) {
        hd[index_1.H_C_META] = JSON.stringify(clientMeta);
    }
    var path = app;
    if (!path.startsWith('/')) {
        path = '/' + path;
    }
    if (!path.endsWith('/')) {
        path += '/';
    }
    if (host.endsWith('/')) {
        host = host.slice(0, -1);
    }
    return [host, path, hd];
}
exports.preproc = preproc;
